<template>
  <div class="navbar-left">
    <div class="navbar-left-languages">
      <span class="navbar-left-languages-icon">
        <app-languages-icon />
      </span>
      <a
        href="javascript:"
        class="navbar-left-languages-link"
        @click="onChange('ro_RO')"
      >
        RO
      </a>
      <span class="divider-vertical"></span>
      <a
        href="javascript:"
        class="navbar-left-languages-link"
        @click="onChange('en_US')"
      >
        EN
      </a>
    </div>
  </div>
</template>

<script>
import AppLanguagesIcon from "@/components/ui/Icons/LanguagesIcon";
export default {
  name: "AppMenuLeft",
  components: {
    AppLanguagesIcon,
  },
  props: {
    locale: {
      type: String,
      required: true,
      default: "ro_RO",
    },
  },
  methods: {
    onChange(value) {
      if (this.locale === value) {
        return;
      }

      this.$emit("localeChange", value);
    },
  },
};
</script>
